import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { ChatInternalSidebarComponent } from '../chat-internal-sidebar/chat-internal-sidebar.component';
import { ChatInternalMessagesComponent } from '../chat-internal-messages/chat-internal-messages.component';
import { ChatInternalInputComponent } from '../chat-internal-input/chat-internal-input.component';
import { ChatInternalPreferencesComponent } from '../chat-internal-preferences/chat-internal-preferences.component';
import { M_SendMessageResponse, M_ChatInternalMessage } from '../../../models/M_ChatInternal';

interface MessageSentEvent extends M_SendMessageResponse {
  userMessage: string;
}
enum BOX_STATE {
  maximized,
  minimized,
}

@Component({
  selector: 'app-chat-internal-widget',
  templateUrl: './chat-internal-widget.component.html',
  styleUrls: ['./chat-internal-widget.component.css'],
  standalone: true,
  imports: [
    MatIconModule,
    MatIconButton,
    CommonModule,
    ChatInternalSidebarComponent,
    ChatInternalMessagesComponent,
    ChatInternalInputComponent,
    ChatInternalPreferencesComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatInternalWidgetComponent {
  status = BOX_STATE.minimized;
  s = BOX_STATE;
  selectedConversationId: number | null = null;

  @ViewChild(ChatInternalMessagesComponent) messagesComponent?: ChatInternalMessagesComponent;
  @ViewChild(ChatInternalSidebarComponent) sidebarComponent?: ChatInternalSidebarComponent;

  constructor() {
    console.log('[ChatInternalWidget] Componente cargado, status:', this.status);
  }

  toggleWidget(): void {
    this.status = this.status === BOX_STATE.maximized ? BOX_STATE.minimized : BOX_STATE.maximized;
  }

  onSelectConversation(id: number): void {
    this.selectedConversationId = id;
    if (this.messagesComponent) {
      this.messagesComponent.conversationId = id;
      this.messagesComponent.loadMessages();
    }
  }

  onNewConversation(): void {
    this.selectedConversationId = null;
  }

  onMessageSent(response: MessageSentEvent): void {
    if (response.conversation_id && !this.selectedConversationId) {
      this.selectedConversationId = response.conversation_id;
      this.sidebarComponent?.refreshConversations();
    }

    if (this.messagesComponent) {
      this.messagesComponent.addMessage({
        id: 0,
        conversation_id: response.conversation_id,
        role: 'user',
        content: response.userMessage,
        sources_json: [],
        tokens_used: 0,
        created_at: new Date().toISOString(),
      });

      this.messagesComponent.addMessage({
        id: 0,
        conversation_id: response.conversation_id,
        role: 'assistant',
        content: response.content,
        sources_json: response.sources,
        tokens_used: response.tokens_used,
        created_at: new Date().toISOString(),
      });
    }
  }
}
